import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import { axios } from "../../../../Global";

function ProfessionalLevelPopup({
  showPromptElement,
  setShowPromptElement,
  setUpdateProfessionList,
}) {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const prevData =
    showPromptElement?.mode === "edit" ? showPromptElement?.data : null;
  const [formData, setFormData] = useState(prevData);
  const [loading, setLoading] = useState(false);
  const [allowSubmit, setAllowSubmit] = useState(
    showPromptElement?.mode !== "edit"
  );

  const validateFormSubmit = () => {
    if (showPromptElement?.mode !== "edit") return false;
    if (
      formData?.name === prevData?.name &&
      formData?.nitakat === prevData?.nitakat &&
      formData?.admin_fee === prevData?.admin_fee &&
      formData?.soundline_fee === prevData?.soundline_fee
    )
      setAllowSubmit(false);
    else setAllowSubmit(true);
  };

  useEffect(() => {
    validateFormSubmit();
  }, [formData]);

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    let response;
    try {
      if (showPromptElement.mode === "create") {
        response = await axios.post(`/dashboard/profession-level`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      } else if (showPromptElement.mode === "edit") {
        response = await axios.put(
          `/dashboard/profession-level/${showPromptElement.id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }
      if (response.status === 200) {
        setLoading(false);
        setShowPromptElement((p) => ({ open: false }));
        setUpdateProfessionList((prev) => !prev);
        dispatch(
          setAppError({
            msg: response.data.message || "Submitted successfully",
            color: "success",
          })
        );
      }
    } catch (err) {
      setLoading(false);
      dispatch(setAppError({ msg: err.message }));
    }
  };
  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
        showPromptElement.open ? "flex" : "hidden"
      }`}
    >
      <div className="max-w-xl w-full max-h-[35rem] min-h-[15rem] overflow-scroll  rounded-md bg-white/95 flex  flex-col py-4 px-8 relative ">
        <div className="flex justify-between items-center w-full mt-1 mb-3">
          <h1 className="text-xl font-semibold">
            {showPromptElement.mode === "edit" ? "Edit" : "Create"} Profession
            Level
          </h1>
          <h1
            className="text-md font-semibold cursor-pointer"
            onClick={() => {
              setShowPromptElement((p) => ({ ...p, open: false }));
            }}
          >
            <IoMdClose />
          </h1>
        </div>
        <form
          className="w-full flex flex-col my-4 gap-3"
          onSubmit={(e) => submitHandler(e)}
        >
          <div className="flex flex-col gap-1">
            <label className="text-sm">PROFESSION LEVEL</label>
            <input
              type="text"
              className="input input-sm input-bordered"
              defaultValue={formData?.name?.toUpperCase()}
              placeholder="ENTER NAME"
              required
              onChange={(e) =>
                setFormData({
                  ...formData,
                  name: e.target.value?.toUpperCase(),
                })
              }
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm">NITKAT</label>
            <input
              type="number"
              step={"0.01"}
              className="input input-sm input-bordered"
              defaultValue={formData?.nitakat}
              placeholder="ENTER NITAKAT"
              required
              pattern="[0-9]*"
              onChange={(e) =>
                setFormData({ ...formData, nitakat: e.target.value })
              }
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm">ADMIN FEE</label>
            <input
              type="number"
              step={"0.01"}
              className="input input-sm input-bordered"
              defaultValue={formData?.admin_fee}
              placeholder="ENTER ADMIN FEE"
              required
              pattern="[0-9]*"
              onChange={(e) =>
                setFormData({ ...formData, admin_fee: e.target.value })
              }
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm">SOUNDLINE FEE</label>
            <input
              type="number"
              step={"0.01"}
              className="input input-sm input-bordered"
              defaultValue={formData?.soundline_fee}
              placeholder="ENTER SOUNDLINE FEE"
              required
              pattern="[0-9]*"
              onChange={(e) =>
                setFormData({ ...formData, soundline_fee: e.target.value })
              }
            />
          </div>
          <div className="flex  gap-3 mx-auto my-3 w-full px-5">
            <button
              className="p-2 px-4 uppercase rounded-md ring-1 ring-slate-300 max-w-xs w-full"
              onClick={() =>
                setShowPromptElement((p) => ({ ...p, open: false }))
              }
              type="button"
            >
              Cancel
            </button>
            <button
              className={`p-2 px-4 rounded-md uppercase ring-1 ring-red bg-red text-white max-w-xs w-full flex items-center justify-center gap-2 
              ${!allowSubmit && "bg-red/50 cursor-not-allowed"}
              `}
              type="submit"
              disabled={!allowSubmit}
              title={`${!allowSubmit && "No changes made"}`}
            >
              Submit {loading && <CgSpinner className="animate-spin" />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ProfessionalLevelPopup;
